/* ============================================================
   SITE PRELOADER
   Erahaus Shopify Theme for Scent of Qui
   ============================================================ */

(function () {
  'use strict';

  var MIN_MS    = 400;
  var MAX_MS    = 1800;
  var FADE_MS   = 600;

  var el        = document.getElementById('site-preloader');
  var startTime = Date.now();
  var fired     = false;

  function dismiss() {
    if (fired) return;
    fired = true;

    var elapsed = Date.now() - startTime;
    var delay   = Math.max(0, MIN_MS - elapsed);

    setTimeout(function () {
      document.documentElement.classList.remove('is-loading');
      document.documentElement.classList.add('is-loaded');

      if (el) {
        setTimeout(function () {
          el.style.visibility = 'hidden';
        }, FADE_MS + 50);
      }
    }, delay);
  }

  /* Safety cap — never block longer than MAX_MS */
  setTimeout(dismiss, MAX_MS);

  /* Primary trigger: all resources loaded */
  if (document.readyState === 'complete') {
    dismiss();
  } else {
    window.addEventListener('load', function () {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(dismiss);
      } else {
        dismiss();
      }
    });
  }

})();
